import { render, staticRenderFns } from "./RAsyncPagedTable.vue?vue&type=template&id=72a7f2b1&scoped=true&"
import script from "./RAsyncPagedTable.vue?vue&type=script&lang=js&"
export * from "./RAsyncPagedTable.vue?vue&type=script&lang=js&"
import style0 from "./RAsyncPagedTable.vue?vue&type=style&index=0&id=72a7f2b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7f2b1",
  null
  
)

export default component.exports